import { Injectable } from '@angular/core';
// import * as async from 'async';
import { Subject, Observable } from 'rxjs';
import { Subscription } from 'rxjs/Subscription';
import { Messages } from '../../../helpers/messages';
import { GDAuthInterface } from '../../../model/gd-auth';
import { AlertServiceProvider } from '../../../providers/alert-service/alert-service';
import { AnalyticsProvider } from '../../../providers/analytics/analytics';
import { FileUploaderProvider, OptionsUploadWithHttp } from '../../../providers/file-uploader/file-uploader';
import { GlobalServiceProvider } from '../../../providers/global-service/global-service';
import { StoragePathProvider } from '../../../providers/storage-path/storage-path';
import { RequestGetFeedDto, RequestSetStatusFeedDto } from '../../../shared/nestjs/gd-only/dto/feed-service.dto';
import {
  RequestGetFollowerDto,
  RequestGetLikeDto,
  RequestSetCommentDto,
  RequestSetLikeDto,
  RequestUnfollowDto
} from '../../../shared/nestjs/gd-only/dto/post-service.dto';
import { FeedServiceNestApi } from '../../../shared/nestjs/gd-only/services/feed-service.api';
import { PostServiceNestApi } from '../../../shared/nestjs/gd-only/services/post-service.api';
import { NestApiProvider } from '../../../shared/nestjs/nest-api';
import { FeedServiceApi, PostServiceApi, RegistrationNewApi, LeaderBoardApi, PaydayLoanServiceApi, SunfishApi, YesdokserviceApi } from '../../../shared/sdk';
import { addPostingParams, ResponseFollower, ResponseFollowing, ResponsePage, NotifBadge, ResponseCheckPolling, FavoriteMenuItem, OptionsOpenPage } from './home.dto';
import { map } from 'rxjs/operators';
import { AppPreferences, Preference } from '../../../shared/local/app-preferences.local';
import { ResourceBookingNestApi } from '../../../shared/nestjs/gd-integrated/services/resource-booking.api';
import { SubscriptionNestApi } from '../../../shared/nestjs/gd-only/services/subscription.api';
import { RegistrationsNestApi } from '../../../shared/nestjs/gd-only/services/registrations.api';
import { RequestGetMyScoreDto, ResponseGetMyScoreDto } from '../../../shared/nestjs/gd-only/dto/leaderboard.dto';
import { LeaderBoardNestApi } from '../../../shared/nestjs/gd-only/services/leaderboard.api';
import { GamificationNestApi } from '../../../shared/nestjs/gd-only/services/gamification.api';
import { PollingBloc } from '../polling/polling.bloc';
import { SF6SPolicyApi } from '../../../shared/nestjs/gd-integrated/services/sf6s-policy.api';
import { Storage } from '@ionic/storage';
import { RequestInboxApi } from '../../../shared/nestjs/gd-all-in-one/services/request-inbox.api';
import { ChatServiceProvider } from '../../../providers/chat-service/chat-service';
import { Events, Platform } from 'ionic-angular';
import moment, { Moment } from 'moment';
import { AnnouncementProvider } from '../../../shared/nestjs/announcement/announcement';
import { PageBuilderGlobal } from '../../../pagebuilder/providers/global';
import { RequestPaging } from '../../../shared/nestjs/gd-all-in-one/dto/claim.dto';
import { PageBuilderMenuProvider } from '../../../pagebuilder/services/menu/repository';
import { YesdokService } from '../../../shared/nestjs/yesdok/yesdok.api';
import { InappbrowserService } from '../../../providers/inappbrowser/inappbrowser.service';
import { TranslateService } from '@ngx-translate/core';
import { NestResponsesProvider } from '../../../shared/nestjs/nest-responses';
import { RequestCountMyApprovalDto, RequestCountMyRequestDto } from '../../../shared/nestjs/gd-all-in-one/dto/request-inbox.dto';
import { IntegrationApi } from '../../../shared/nestjs/integration/integration';
import { EventNameAnalytics } from '../../../helpers/event-name-analytics';
import { PolicyApi } from '../../../shared/nestjs/gd-only/services/policy.api';
import async from 'async';
declare const cordova;

/*
  Generated class for the ChangeAccessBloc provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class HomeBloc {
  public subscriptions: Array<Subscription> = [];
  public uploadPostDone: Subject<boolean> = new Subject<boolean>();
  public isSendPost: Subject<boolean> = new Subject<boolean>();
  private myBadge: any;
  public isDisabled: boolean;
  public isDisabledSubject: Subject<boolean> = new Subject<boolean>();
  public showNotif: boolean;
  public emergencyAnnoucement: boolean;

  public showBadgeNotif = 0;
  public requestBadge: NotifBadge = {
    request: 0,
    approval: 0
  }

  private _showSurvey: boolean = true;
  public languageSelectedLabel;
  public languageSelected;
  private _favoriteMenu: FavoriteMenuItem[] = [];
  private _partnerCovid;

  constructor(
    private feedServiceNestApi: FeedServiceNestApi,
    private postServiceNestApi: PostServiceNestApi,
    private feedServiceApi: FeedServiceApi,
    private postServiceApi: PostServiceApi,
    private globalService: GlobalServiceProvider,
    public nestApiProvider: NestApiProvider,
    private storagePathProvider: StoragePathProvider,
    private alertService: AlertServiceProvider,
    private analyticsProvider: AnalyticsProvider,
    public fileUploadProvider: FileUploaderProvider,
    private appPreferences: AppPreferences,
    private resourceBookingNestApi: ResourceBookingNestApi,
    private subscriptionNestApi: SubscriptionNestApi,
    private registrationsNestApi: RegistrationsNestApi,
    private registrationNewApi: RegistrationNewApi,
    private leaderBoardNestApi: LeaderBoardNestApi,
    private leaderBoardApi: LeaderBoardApi,
    private gamificationNestApi: GamificationNestApi,
    private pollingBloc: PollingBloc,
    private sf6sPolicyApi: SF6SPolicyApi,
    private policyApi: PolicyApi,
    private storage: Storage,
    private requestInboxApi: RequestInboxApi,
    private chatServiceProvider: ChatServiceProvider,
    private events: Events,
    private platform: Platform,
    private payDayLoanServiceApi: PaydayLoanServiceApi,
    private announcementProvider: AnnouncementProvider,
    private pageBuilderGlobal: PageBuilderGlobal,
    private menuRepository: PageBuilderMenuProvider,
    private sunfishApi: SunfishApi,
    private yesdokService: YesdokService,
    private inAppBrowserService: InappbrowserService,
    private yesDokServiceApi: YesdokserviceApi,
    private translate: TranslateService,
    private nestResponse: NestResponsesProvider,
    private integrationApi: IntegrationApi,
  ) {
  }

  getFeed(params: RequestGetFeedDto): Promise<Array<any>> {
    return new Promise(async (resolve, reject) => {
      let response = [];
      try {
        response = await this.getFeedNestApi(params)
        resolve(response);
      }
      catch (error) {
        reject(error)
      }
    })
  }

  getFeedNestApi(params: RequestGetFeedDto): Promise<Array<any>> {
    return new Promise(async (resolve, reject) => {
      this.subscriptions.push(
        this.feedServiceNestApi.getFeed(params)
          .subscribe(result => {
            let response = [];
            if (result.data.length > 0) {
              for (let item of result.data) {
                if (item.empOwner) {
                  response.push(item);
                }
              }
            }
            resolve(response)
          }, error => {
            reject(error)
          })
      );
    })
  }

  getFeedLoopbackApi(params: RequestGetFeedDto): Promise<Array<any>> {
    return new Promise((resolve, reject) => {
      let response = [];
      this.subscriptions.push(
        this.feedServiceApi.getFeed(params)
          .subscribe(async (result) => {
            if (result.success) {
              if (result.data.length > 0) {
                const data = await this.globalService.convertKeyArrObjFeed(result.data);
                console.log('feed convert', data);
                for (let item of data) {
                  if (item.empOwner) {
                    response.push(item);
                  }
                }
              }
            }

            resolve(response)
          }, error => {
            reject(error)
          })
      );
    })
  }

  setStatusFeed(params: RequestSetStatusFeedDto, isGopathNew: boolean): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      const feedServiceApi = isGopathNew ? this.feedServiceNestApi.setStatusFeed(params) : this.feedServiceApi.setStatusFeed(params);
      this.subscriptions.push(
        feedServiceApi.subscribe(() => {
          resolve(true)
        }, error => {
          reject(error);
        })
      )
    })
  }

  addPosting(params: addPostingParams): Promise<boolean> {
    return new Promise(async (resolve) => {
      this.isSendPost.next(true)
      this.uploadPostDone.next(false);
      let savePost: boolean;
      let pictureList = params.postId ? params.pictureEditList : [];

      if (params.picture.length > 0) {
        this.storagePathProvider.getStoragePost().then((val) => {

          async.eachOfSeries(params.picture, async (items, key, callback) => {
            let item = items as any
            const date = new Date();
            const fileName = date.getTime() + '.jpg';
            // let file = this.platform.is('cordova') ? item.data : item.eventsWebview[0];
            const options: OptionsUploadWithHttp = {
              type: 'image',
              nativeURI: item.data ? item.data : null,
              eventsWebview: item.eventsWebview ? item.eventsWebview : null,
              options: item.options ? item.options : fileName
            }

            try {
              const response = await this.fileUploadProvider.uploadWithHttp(options, val.urlUpload);
              if (response) {
                pictureList.push(response);
              }
            }
            catch (error) { }

            if (key == params.picture.length - 1) {
              this.uploadPostDone.next(true);
            }

            callback();
          }, async (err) => {
            if (err) {
              this.isSendPost.next(false);
              resolve(false)
            }

            if (pictureList.length > 0) {
              savePost = params.postId ? await this.updatePost(params, pictureList) : await this.savePost(params, pictureList);
              resolve(savePost)
            } else {
              this.alertService.createMola(Messages.FAILED_SENDING_PHOTO)
              this.isSendPost.next(false);
              resolve(false)
            }

          })
        }).catch(error => {
          this.isSendPost.next(false);
          resolve(false)
        })
      } else {
        this.uploadPostDone.next(true);
        savePost = params.postId ? await this.updatePost(params, pictureList) : await this.savePost(params, pictureList);
        resolve(savePost);
      }
    })
  }

  savePost(params: addPostingParams, pictureList?: Array<any>): Promise<boolean> {
    return new Promise((resolve) => {
      // let formData = {
      //   content: params.content,
      //   picture: "",
      //   photoUser: params.empphotopath,
      //   photoContent: '',
      //   flag: params.isAchievement,
      //   attachment: pictureList,
      // }

      let formDataNest = {
        content: params.content,
        picture: "",
        flagAchievement: params.isAchievement,
        sharedEmp: null,
        attachment: pictureList,
        taskCode: null,
      }


      const postServiceApi = this.postServiceNestApi.setPost(formDataNest);

      this.subscriptions.push(
        postServiceApi.subscribe(val => {
          this.analyticsProvider.trackEvent(EventNameAnalytics.GREATDAY_FEEDS_ADD_POST, val);
          resolve(true)
        }, error => {
          this.nestApiProvider.responseError(error);
          this.analyticsProvider.trackEvent(EventNameAnalytics.GREATDAY_FEEDS_ADD_POST_FAILED, error);
          resolve(false)
        })
      )
    })
  }

  updatePost(params: addPostingParams, pictureList?: Array<any>): Promise<boolean> {
    return new Promise((resolve) => {
      const formData = {
        postId: params.postId,
        content: params.content,
        flag: params.isAchievement,
        attachment: pictureList
      }

      const feedServiceApi = params.isGopathNew ? this.feedServiceNestApi.editStatusFeed(formData) : this.feedServiceApi.editStatusFeed(formData);

      this.subscriptions.push(
        feedServiceApi.subscribe(val => {
          resolve(true);
        }, error => {
          this.nestApiProvider.responseError(error);
          resolve(false);
        })
      )
    })
  }

  getStatusFeed(data): Promise<{ pbCustom: boolean, flag: boolean }> {
    return new Promise((resolve) => {
      let response = {
        pbCustom: false,
        flag: true
      }

      const feedServiceApi = data.isGopathNew ? this.feedServiceNestApi.getStatusFeed({ feedId: data.id }) : this.feedServiceApi.getStatusFeed(data.id);

      this.subscriptions.push(
        feedServiceApi.subscribe(result => {
          const val = data.isGopathNew ? result.data : result;
          if (val.length != 0) {
            if (val[0].flag == data.flag) {
              if (!data.hasOwnProperty('pbCustom')) {
                resolve(response)
              } else {
                response.pbCustom = true;
                resolve(response)
              }
            } else {
              response.flag = false;
              resolve(response)
            }
          } else {
            response.flag = false;
            resolve(response)
          }
        }, error => {
          response.flag = false;
          resolve(response)
        })
      )
    })
  }


  setLike(payload: RequestSetLikeDto): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.apiSetLike(payload)
          .subscribe((result) => {
            this.analyticsProvider.trackEvent(EventNameAnalytics.GREATDAY_FEEDS_LIKE_POST);
            resolve(result);
          }, error => {
            this.analyticsProvider.trackEvent(EventNameAnalytics.GREATDAY_FEEDS_LIKE_POST_FAILED, error);
            reject(error);
          })
      )
    })
  }

  apiSetLike(payload: RequestSetLikeDto): Observable<any> {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(isGoPathNewExist => {
        if (isGoPathNewExist) {
          return this.postServiceNestApi.setLike(payload).pipe(map((item) => true));
        } else {
          return this.postServiceApi.setLike(payload).pipe(map((item) => {
            if (item.success) {
              return true;
            }
            return false;
          }));
        }
      })
  }

  getComment(params, isGopathNew: boolean, isLoadMore: boolean): Promise<{ totalPage: number, totalComment: number, data: Array<any> }> {
    return new Promise((resolve) => {
      let response = {
        totalPage: 1,
        totalComment: 0,
        data: []
      }

      const postServiceApi = isGopathNew ? this.postServiceNestApi.getComment(params) : this.postServiceApi.getComment(params);

      this.subscriptions.push(
        postServiceApi.subscribe(async (val) => {
          if (val.data && val.data.length > 0) {
            response.totalComment = isGopathNew ? val.total : val.data.length;
            let dataComment = await this.globalService.convertArrObjToCamelCase(val.data);
            response.data = isLoadMore ? dataComment : dataComment.reverse();
          }

          response.totalPage = isGopathNew ? val.totalPage : 1;
          resolve(response);
        }, error => {
          resolve(response)
        })
      );
    })
  }

  setComment(params: RequestSetCommentDto, isGopathNew: boolean): Promise<boolean> {
    return new Promise((resolve) => {
      const postServiceApi = isGopathNew ? this.postServiceNestApi.setComment(params) : this.postServiceApi.setComment(params);

      this.subscriptions.push(
        postServiceApi.subscribe(val => {
          this.analyticsProvider.trackEvent(EventNameAnalytics.GREATDAY_FEEDS_COMMENT_POST);
          resolve(true);
        }, error => {
          this.analyticsProvider.trackEvent(EventNameAnalytics.GREATDAY_FEEDS_COMMENT_POST_FAILED, error);
          resolve(false);
        })
      )
    })
  }

  setStatusPost(params: { postId: number, flag: string }, isGopathNew: boolean): Promise<any> {
    return new Promise((resolve) => {
      const postServiceApi = isGopathNew ? this.postServiceNestApi.setStatusPost(params) : this.postServiceApi.setStatusPost(params);

      this.subscriptions.push(
        postServiceApi.subscribe(() => {
          resolve(true);
        }, error => {
          this.alertService.createMola(Messages.FAILED);
          resolve(false);
        })
      );
    })
  }

  getFollowing(params, isGopathNew): Promise<ResponseFollowing> {
    return new Promise(async (resolve) => {
      const result = isGopathNew ? await this.getFollowingNestApi(params) : await this.getFollowingLoopbackApi(params);
      resolve(result);
    })
  }

  getFollowingLoopbackApi(params: { empId: string }): Promise<ResponseFollowing> {
    return new Promise((resolve) => {
      let result = {
        totalFollowing: 0,
        data: []
      }

      this.subscriptions.push(
        this.postServiceApi.getFollowing(params)
          .subscribe(val => {
            if (val.status) {
              for (let i of val.data) {
                if (i.status != 0) {
                  result.data.push(i);
                }
              }
            }

            result.totalFollowing = result.data.length;
            resolve(result);
          }, error => {
            resolve(result);
          })
      );
    })
  }

  getFollowingNestApi(params: { empId: string, page: number, limit: number }): Promise<ResponseFollowing> {
    return new Promise((resolve) => {
      let result = {
        totalFollowing: 0,
        data: []
      }

      this.subscriptions.push(
        this.postServiceNestApi.getFollowing(params)
          .subscribe(val => {
            for (let i of val.data) {
              if (i.status != 0) {
                result.data.push(i);
              }
            }

            result.totalFollowing = val.total;
            resolve(result);
          }, error => {
            resolve(result);
          })
      );
    })
  }

  getFollower(params, isGopathNew, SFGoAuth: GDAuthInterface): Promise<ResponseFollower> {
    return new Promise(async (resolve) => {
      const result = isGopathNew ? await this.getFollowerNestApi(params, SFGoAuth) : await this.getFollowerLoopbackApi(params, SFGoAuth);
      resolve(result);
    })
  }

  getFollowerNestApi(params: RequestGetFollowerDto, SFGoAuth: GDAuthInterface): Promise<ResponseFollower> {
    return new Promise((resolve) => {
      let result: ResponseFollower = {
        statusFollow: 'Follow',
        totalFollower: 0,
        data: []
      }

      this.subscriptions.push(
        this.postServiceNestApi.getFollower(params)
          .subscribe(val => {
            let data = this.getUnique(val.data, 'followerId');
            const index = data.findIndex(index => index.followerId === SFGoAuth.empId)
            if (index !== -1) {
              if (data[index].status == false) {
                result.statusFollow = 'Requested';
              } else {
                result.statusFollow = 'Following';
              }
            }

            if (val.message) {
              result.statusFollow = val.message;
            }

            let tempData = [];
            for (let i of data) {
              if (i.status != 0) {
                tempData.push(i);
              } else {
                if (index.followerId === SFGoAuth.empId) {
                  tempData.push(i);
                }
              }
            }

            result.totalFollower = val.total;
            result.data = tempData;
            resolve(result);
          }, error => {
            resolve(result);
          })
      );
    })
  }

  getFollowerLoopbackApi(params: RequestGetFollowerDto, SFGoAuth: GDAuthInterface): Promise<ResponseFollower> {
    return new Promise((resolve) => {
      let result: ResponseFollower = {
        statusFollow: 'Follow',
        totalFollower: 0,
        data: []
      }

      this.subscriptions.push(
        this.postServiceApi.getFollower(params)
          .subscribe(val => {
            let data = this.getUnique(val.data, 'followerId');
            const index = data.findIndex(index => index.followerId === SFGoAuth.empId)
            if (index !== -1) {
              if (data[index].status == false) {
                result.statusFollow = 'Requested';
              } else {
                result.statusFollow = 'Following';
              }
            }

            let tempData = [];
            for (let i of data) {
              if (i.status != 0) {
                tempData.push(i);
              } else {
                if (index.followerId === SFGoAuth.empId) {
                  tempData.push(i);
                }
              }
            }

            result.totalFollower = tempData.length;
            result.data = tempData;
            resolve(result);
          }, error => {
            resolve(result);
          })
      );
    })
  }

  getUnique(data, listFollower) {
    const unique = data
      .map(e => e[listFollower])
      // store the keys of the unique objects
      .map((e, i, final) => final.indexOf(e) === i && i)
      // eliminate the dead keys & store unique objects
      .filter(e => data[e]).map(e => data[e]);
    return unique;
  }

  /**
   * Follow and unfollow toggle
   */
  setFollow(params: { statusFollow: string, empId: string, isGopathNew: boolean }): Promise<{ statusFollow: string }> {
    return new Promise((resolve, reject) => {
      let payload = {
        empId: params.empId,
        status: null
      }

      let result = {
        statusFollow: params.statusFollow
      };

      if (params.statusFollow == 'Follow') {
        payload.status = 'Request';
        result.statusFollow = 'Requested'
      }
      else if (params.statusFollow == 'Requested') {
        payload.status = 'Cancel';
        result.statusFollow = 'Follow'
      }
      else if (params.statusFollow == 'Following') {
        payload.status = 'Unfollow';
        result.statusFollow = 'Unfollow'
      }

      const postServiceApi = params.isGopathNew ? this.postServiceNestApi.setFollow(payload) : this.postServiceApi.setFollow(payload);
      this.subscriptions.push(
        postServiceApi.subscribe(val => {
          resolve(result);
        }, error => {
          reject(error)
        })
      );
    })
  }

  unFollow(id: any): Observable<any> {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(
        isGoPathNewExist => {
          if (isGoPathNewExist) {
            let data: RequestUnfollowDto = new RequestUnfollowDto()
            data.empId = id
            return this.postServiceNestApi.unFollow(data)
          }
        }
      )
  }

  approveFollower(params: { empId: string, follower: any, isGopathNew: boolean }): Promise<{ follower: { status: boolean } }> {
    return new Promise((resolve, reject) => {
      const payload = {
        empId: params.empId,
        id: params.follower.id
      }

      const postServiceApi = params.isGopathNew ? this.postServiceNestApi.setFollowApprove(payload) : this.postServiceApi.setFollowApprove(payload);

      this.subscriptions.push(
        postServiceApi.subscribe(val => {
          params.follower.status = params.isGopathNew ? true : val.status ? true : false;
          resolve(params)
        }, error => {
          reject(params)
        })
      );
    })
  }

  getLike(payload: RequestGetLikeDto, isGopathNew: boolean): Promise<ResponsePage> {
    return new Promise((resolve, reject) => {
      let result = {
        totalPage: 1,
        data: []
      }

      const postServiceApi = isGopathNew ? this.postServiceNestApi.getLike(payload) : this.postServiceApi.getLike(payload);

      this.subscriptions.push(
        postServiceApi.subscribe(async (val) => {
          if (val.data.length > 0) {
            const data = await this.globalService.convertArrObjToCamelCase(val.data);

            if (!isGopathNew && val.status) {
              for (let item of data) {
                result.data.push(item);
              }
            }
            else if (isGopathNew) {
              for (let item of data) {
                result.data.push(item);
              }
            }
          }

          result.totalPage = isGopathNew ? val.totalPage : 1;
          resolve(result)
        }, error => {
          reject(error)
        })
      )
    })
  }

  formatDataAttSendOffline(SFGoAuth: GDAuthInterface, record: Array<any>) {
    return new Promise(async (resolve) => {
      if (SFGoAuth) {
        let tempArr = [];

        for (let list of record) {
          let temp: any = {};
          if (SFGoAuth.isSF6) {
            if (list.isbarcode) {
              temp = {
                barcode: list.barcode || null,
                compid: SFGoAuth.companyId || null,
                datetime: list.datetime || null,
                empid: SFGoAuth.empId || null,
                photo: list.photo || null,
                flagInputStatus: null,
                geolocation: list.geolocation || null,
                att_on: "offline",
                message: list.message || 'There are not message',
                error: list.error || []
              }
            }
            else {
              temp = {
                companyId: SFGoAuth.companyId || null,
                photoUrl: list.photoUrl || null,
                geolocation: list.geolocation || null,
                attOn: "offline",
                datetime: list.datetime || null,
                empid: SFGoAuth.empId || null,
                photo: list.photo || null,
                message: list.message || 'There are not message',
                error: list.error || []
              }
            }
          }
          else {
            if (list.isbarcode) {
              temp = {
                barcode: list.barcode.text || null,
                record: {
                  photoUrl: list.photoUrl || null,
                  geolocation: list.geolocation || null,
                  attOn: "offline",
                  time: list.datetime || null,
                  picture: list.photo || null,
                  flagButton: "",
                },
                message: list.message || 'There are not message',
                error: list.error || []
              }
            }
            else {
              temp = {
                photoUrl: list.photoUrl || null,
                geolocation: list.geolocation || null,
                attOn: "offline" || null,
                time: list.datetime || null,
                picture: list.photo || null,
                flagButton: {
                  innow: true,
                  outnow: true,
                  inyesterday: false,
                  outyesterday: false,
                  intomorrow: false
                },
                message: list.message || 'There are not message',
                error: list.error || []
              }
            }
          }
          tempArr.push(temp);
        }

        resolve(tempArr);
      }
      else {
        resolve(null);
      }
    })
  }

  dispose() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  async getPolling(): Promise<boolean> {
    const polling = await this.appPreferences.getPolling();
    return (polling) ? true : false;
  }

  processResourceBooking(action, params): Promise<any> {
    return new Promise(async (resolve, reject) => {
      params['action'] = action;
      this.subscriptions.push(
        this.resourceBookingNestApi.startEndBooking(params)
          .subscribe(result => {
            resolve(result);
          }, error => {
            reject(error);
          })
      );

    })
  }

  updateSubscriptionDashboard() {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.subscriptionNestApi.getRequestDashboard()
          .pipe(map(result => result.data))
          .subscribe(result => {
            resolve(result)
          }, error => {
            reject(error)
          })
      )
    })
  }

  dataOnBoarding(payload: { type: string }) {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.dataOnBoardingApi(payload)
          .subscribe(result => {
            resolve(result)
          }, error => {
            reject(error)
          })
      )
    })
  }

  private dataOnBoardingApi(payload: { type: string }): Observable<any> {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(
        isGoPathNewExist => {
          if (isGoPathNewExist) {
            return this.registrationsNestApi.dataOnboarding(payload).pipe(map(result => result.data))
          } else {
            return this.registrationNewApi.dataOnboarding(payload);
          }
        }
      )
  }

  getMyScore(payload: RequestGetMyScoreDto) {
    return new Promise<ResponseGetMyScoreDto[]>((resolve, reject) => {
      this.subscriptions.push(
        this.getMyScoreApi(payload)
          .subscribe(result => {
            resolve(result)
          }, error => {
            reject(error)
          })
      )
    })
  }

  private getMyScoreApi(payload: RequestGetMyScoreDto): Observable<any> {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(
        isGoPathNewExist => {
          if (isGoPathNewExist) {
            return this.leaderBoardNestApi.getMyScore(payload).pipe(map(result => result.data))
          } else {
            return this.leaderBoardApi.getMyScore(payload);
          }
        }
      )
  }

  getProfileAchievement(empId: any) {
    return new Promise<Array<any>>((resolve, reject) => {
      this.subscriptions.push(
        this.gamificationNestApi.achievementInProfile({ empId: empId })
          .map(res => res.data)
          .subscribe(result => {
            resolve(result)
          }, error => {
            console.log(error);
            reject(error)
          })
      );
    })
  }

  getBadgeOnAvatar(empId: string) {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.gamificationNestApi.getAvatar(empId)
          .map(res => res.data)
          .subscribe(result => {
            resolve(result)
          }, error => {
            console.log(error);
            reject(error)
          })
      );
    })
  }

  setMyBadge(badge) {
    this.myBadge = badge;
  }

  getMyBadge() {
    return this.myBadge;
  }

  checkPollingAfterLogin() {
    return new Promise<ResponseCheckPolling>(async (resolve) => {
      const arrayPoll = await this.pollingBloc.getPollingFromStorage();
      let result: ResponseCheckPolling = {
        page: '',
        params: null,
        restrict: false
      }

      if (arrayPoll) {
        const idx = arrayPoll.findIndex(i => i.prompt === 'after_login');
        if (idx != -1) {
          const poll = arrayPoll[idx];
          if (poll && poll.prompt === 'after_login') {
            result.restrict = poll.restrict;
            result.page = 'PollingWelcomePage';
            result.params = poll;
          }
        } else {
          result = await this.getTrackPolicy();
        }
      } else {
        result = await this.getTrackPolicy();
      }

      resolve(result);
    });
  }

  getTrackPolicy() {
    return new Promise<ResponseCheckPolling>(async (resolve) => {
      const result: ResponseCheckPolling = {
        page: '',
        params: null,
        restrict: true
      };

      try {
        this.isDisabled = false;
        this.isDisabledSubject.next(false);

        const SFGoAuth = await this.appPreferences.getAuth();
        if (SFGoAuth.isSF6) {
          const resPolicy = await this.sf6sPolicyApi.trackPolicy()
            .toPromise()

          if (resPolicy.data.length > 0) {
            result.page = 'TrackPolicyPage';
            result.params = resPolicy.data;
          }
        } else {
          const resPolicy = await this.policyApi.getTrackPolicy({ limit: 50, page: 1 })
            .map(res => res.data)
            .toPromise()

          if (resPolicy.length > 0) {
            result.page = 'PrivacyPolicyPage';
            result.params = resPolicy;
          }
        }
      } catch (_) { }

      resolve(result);
    });
  }

  async checkPollingBeforeAttendance(): Promise<ResponseCheckPolling> {
    const result: ResponseCheckPolling = {
      page: '',
      params: null,
      restrict: false,
      onDidDismiss: false,
    };

    const arrayPoll = await this.pollingBloc.getPollingFromStorage();
    if (arrayPoll) {
      const idx = arrayPoll.findIndex(i => i.prompt == 'before_attendance');
      if (idx != -1) {
        const poll = arrayPoll[idx];
        if (poll && poll.prompt == 'before_attendance') {
          result.restrict = poll.restrict;
          result.page = 'PollingWelcomePage';
          result.params = poll;
          result.onDidDismiss = !poll.restrict ? true : false;
        }
      }
    }

    return result;
  }

  async checkPollingAfterAttendance() {
    const result: ResponseCheckPolling = {
      page: '',
      params: null,
      restrict: false
    };

    const arrayPoll = await this.pollingBloc.getPollingFromStorage();
    if (arrayPoll) {
      const idx = arrayPoll.findIndex(i => i.prompt == 'after_attendance');
      if (idx != -1) {
        const poll = arrayPoll[idx];
        if (poll && poll.prompt == 'after_attendance') {
          result.restrict = poll.restrict;
          result.page = 'PollingWelcomePage';
          result.params = poll;
        }
      }
    }

    return result;
  }

  async setPollingStorage(surveyCode: any) {
    const arrayPoll = await this.pollingBloc.getPollingFromStorage();
    const idx = arrayPoll.findIndex(i => i.surveyCode == surveyCode);
    if (idx != -1) {
      arrayPoll.splice(idx, 1);
      await this.pollingBloc.setPollingToStorage(arrayPoll);
    }
  }

  async announcementEmergency() {
    try {
      const global = await this.storage.get("globalAnnouncement");
      if (global) {
        if (global.show) {
          this.showNotif = true;
          this.emergencyAnnoucement = global;
        } else {
          this.showNotif = false;
        }
      } else {
        this.showNotif = false;
      }
    } catch (error) {
      this.showNotif = false;
    }
  }

  async getBadgeRequest() {
    try {
      const payload: RequestCountMyRequestDto = {
        userId: this.appPreferences.dataAuth.userId,
        isSF6: this.appPreferences.dataAuth.isSF6
      }

      const request = await this.requestInboxApi.countMyRequest(payload)
        .map((res => res.data))
        .toPromise();

      this.requestBadge.request = request;
    } catch (error) {
      this.requestBadge.request = 0;
    }

    return this.requestBadge;
  }

  async getBadgeApproval() {
    try {
      const payload: RequestCountMyApprovalDto = { userId: this.appPreferences.dataAuth.userId }
      const approval = await this.requestInboxApi.countMyApproval(payload)
        .map((res => res.data))
        .toPromise();

      this.requestBadge.approval = approval;
    } catch (error) {
      this.requestBadge.approval = 0;
    }

    return this.requestBadge;
  }

  getUnreadChat() {
    this.subscriptions.push(
      this.chatServiceProvider.getUnreadMsg()
        .subscribe((result) => {
          try {
            this.chatServiceProvider.setUnreadCount = result.data;
            this.events.publish('chat:unreadCount', this.chatServiceProvider.getUnreadCount);
          } catch (error) {
            console.log(error)
          }
        }, error => {
          console.log(error)
        })
    )
  }

  get checkSurvey(): boolean {
    const data = localStorage.getItem('surveyAlert');
    if (this.platform.is('cordova')) {
      window.open = cordova.InAppBrowser.open;
    }

    if (!data) {
      localStorage.setItem('surveyAlert', '1');
      return true;
    } else {
      if (localStorage.getItem('surveyAlert') === '0') {
        return false;
      }
    }

    return true;
  }

  closeSurvey() {
    localStorage.setItem('surveyAlert', '0');
    this._showSurvey = false;
    return this._showSurvey;
  }

  openGiveFeedback(surveyLink) {
    window.open(surveyLink, '_system');
    localStorage.setItem('surveyAlert', '0');
    this._showSurvey = false;
    return this._showSurvey;
  }

  get showSurvey() {
    return this._showSurvey;
  }

  /** function for get danafix provider */
  getDanafixProvider(): Promise<any> {
    return new Promise((resolve, reject) => {
      try {
        this.payDayLoanServiceApi.getRequest('getPaydayProvider', {}).subscribe((res: any[]) => {
          const filterRes = res.filter(item => {
            return item.partnerId === 12;
          });

          if (filterRes.length) {
            resolve(filterRes[0]);
          } else {
            reject('Danafix provider not found');
          }
        });
      } catch (err) {
        reject(err);
      }
    });
  }

  async initLocaleMomentJS(): Promise<any> {
    return new Promise(async (resolve) => {
      let language = await this.storage.get("language");

      if (language == 'id') {
        moment.locale('id')
      }
      else {
        moment.locale('en')
      }
      resolve(true);
    })
  }

  initLanguage(): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        await this.storage.ready();
        const language = await this.storage.get("language");

        if (language) {
          this.languageSelected = language;
          if (this.languageSelected == 'en') {
            this.languageSelectedLabel = 'English'
          } else if (this.languageSelected == 'id') {
            this.languageSelectedLabel = 'Indonesia'
          } else if (this.languageSelected == 'th') {
            this.languageSelectedLabel = 'Thailand'
          } else if (this.languageSelected == 'cn') {
            this.languageSelectedLabel = 'Chinese'
          } else if (this.languageSelected == 'kr') {
            this.languageSelectedLabel = 'Korean'
          } else if (this.languageSelected == 'jp') {
            this.languageSelectedLabel = 'Japanese'
          } else if (this.languageSelected == 'my') {
            this.languageSelectedLabel = 'Malaysia'
          }
        }

        resolve(true);
      } catch (error) {
        resolve(true);
      }
    })
  }

  getAnnouncement(auth: GDAuthInterface, payload: RequestPaging, language: string) {
    if (auth.isSF6) {
      return this.getAnnouncementSF6(language);
    } else {
      return this.getAnnoucementGD(payload);
    }
  }

  getAnnoucementGD(payload: RequestPaging) {
    return new Promise<Array<any>>((resolve, reject) => {
      this.announcementProvider.getAnnouncement(payload.page, payload.limit)
        .subscribe(async (result) => {
          let now = moment(new Date()); //todays date
          let index = 0;
          let data = [];

          if (result.data.length > 0) {
            for (let item of result.data) {
              if (index < 3) {
                let duration = moment.duration(now.diff(moment(item.createdDate.raw))).asDays();
                item.createdDate.duration = duration;
                item.preview = item.description.replace(/(\<br\s*\/?\>\s*)+/gi, '\n').replace(/^\<br>/i, '');
                data.push(item);
              }
              index++;
            }
          }

          await this.appPreferences.setGreatdayStorage(Preference.Announcement, data);
          resolve(data)
        }, error => {
          reject(error);
        })
    })
  }

  getAnnouncementSF6(language: string) {
    return new Promise<Array<any>>(async (resolve, reject) => {
      const route = "ofid=CompanyGD.listingAnnouncement";
      const params = [{
        paramKey: "limit",
        paramValue: 3
      },
      {
        paramKey: "page",
        paramValue: 1
      },
      {
        paramKey: "lang",
        paramValue: language || 'en'
      }]

      try {
        const result = await this.pageBuilderGlobal.cfcDirectApi(route, params);
        let now = moment(new Date()); //todays date
        let index = 0;
        let data = [];

        if (result.data.length > 0) {
          for (let item of result.data) {
            if (index < 3) {
              let duration = moment.duration(now.diff(moment(item.createdDate.raw))).asDays();
              item.createdDate.duration = duration;
              item.preview = item.description.replace(/(\<br\s*\/?\>\s*)+/gi, '\n').replace(/^\<br>/i, '');
              data.push(item);
            }
            index++;
          }
        }
        await this.appPreferences.setGreatdayStorage(Preference.Announcement, data);
        resolve(data);
      } catch (error) {
        reject(error)
      }
    });
  }

  getFavoriteMenu(): Promise<void> {
    return new Promise(async (resolve) => {
      this._favoriteMenu = [];
      let favMenus = await this.menuRepository.getFavoriteMenu();
      favMenus.forEach(element => {
        if (element.show) {
          this._favoriteMenu.push(element);
        }
      });

      resolve();
    })
  }

  get favoriteMenu() {
    return this._favoriteMenu;
  }

  async updateStorageAuthSF6() {
    try {
      let auth = await this.appPreferences.getAuth();
      const updateStorage = auth.updateStorage;
      if (updateStorage != undefined && updateStorage != null) {
        const result = await this.sunfishApi.refreshStorage(updateStorage).toPromise();
        if (result.updateStatus == true) {
          auth.functionAuth = result.functionAuth;
          auth.updateStorage = new Date().toISOString();
          this.appPreferences.setGreatdayStorage(Preference.Auth, auth);
        }
      }
    } catch (error) { }
  }

  async goToYesdok() {
    const txt = this.translate.instant(Messages.YESDOK_CONFIRM_MESSAGE_TERM);
    const confirm = await this.alertService.ConfirmYesdok(txt);
    if (confirm) {
      try {
        const response = await this.yesdokService.getYesdokUrl({ route: "Business/Consultation" }).toPromise();
        if (response.data.url) {
          this.inAppBrowserService.openInAppBrowser(response.data.url, '_system');
        } else {
          this.alertService.createMola(response.message)
        }
      } catch (error) {
        this.nestResponse.error(error);
      }
    }
  }

  async goToCovid19() {
    let isConsult = false;
    const confirm = await this.alertService.ConfirmYesdok(Messages.YESDOK_CONFIRM_MESSAGE);
    if (confirm) {
      this.yesDokServiceApi.getRequest({ route: "User/Covid" })
        .timeout(60 * 2 * 1000)
        .subscribe(resp => {
          if (resp.Code === 101) {
            this._partnerCovid = resp.Data.Url.substring(resp.Data.Url.indexOf("partner=") + 8, resp.Data.Url.length)
            const browser = this.inAppBrowserService.openInAppBrowser(resp.Data.Url, '_system');

            if (this.platform.is("cordova")) {
              let loop = setInterval(() => {
                const params = {
                  route: "checkCallback",
                  partner: this._partnerCovid
                }

                this.yesDokServiceApi.getRequest(params)
                  .subscribe(resp => {
                    if (resp.action == "close") {
                      browser.close();
                      clearInterval(loop);
                    } else if (resp.action == "call" && !isConsult) {
                      clearInterval(loop);
                      isConsult = true
                      this.goConsult(browser);
                    }
                  }, _ => { })
              }, 4000);

              browser.on("exit").subscribe(() => {
                clearInterval(loop);
              })
            }
          } else {
            this.alertService.createMola(resp.Msg);
          }
        });
    }
  }

  goConsult(brows) {
    let clear = false;
    let tempTimer = setTimeout(() => {
      if (clear) {
        clearTimeout(tempTimer)
      } else {
        brows.close()
        clearTimeout(tempTimer)
      }
    }, 15000)

    const params = {
      route: "User/Consultation",
      partner: this._partnerCovid
    }

    this.yesDokServiceApi.getRequest(params)
      .subscribe(async resp => {
        clear = true;
        brows.close()
        if (resp.Code === 101 || resp.Code === 201) {
          if (this.platform.is("cordova")) {
            this.inAppBrowserService.openInAppBrowser(resp.Data.Url, '_system')
          }
        } else {
          this.alertService.createMola(resp.Msg)
        }
      }, error => {
        clear = true;
        brows.close();
        this.nestApiProvider.responseError(error)
      });
  }

  async goToAsaren(menuCode: string) {
    try {
      const response = await this.integrationApi.asaren(menuCode).toPromise();
      if (response.data) {
        this.inAppBrowserService.openInAppBrowser(`${response.data.link}`, '_system');
      } else {
        this.alertService.createMola(response.message)
      }
    } catch (error) {
      this.nestResponse.error(error);
    }
    return true;
  }

  openPageStatic(page: string, params?: any, type: 'push' | 'setRoot' = 'push', onDidDismiss = false) {
    const options: OptionsOpenPage = {
      pageStatic: page,
      typeMenu: type,
      params: params,
      onDidDismiss: onDidDismiss
    }

    this.events.publish('user:openPage', options);
  }

  afterPageDismiss(event) {
    return new Promise((resolve) => {
      this.events.unsubscribe(event);
      this.events.subscribe(event, data => {
        resolve(data);
      });
    })
  }

  reloadTabs(currentReload: Moment) {
    const result = {
      reload: false,
      currentReload: currentReload
    };

    const lastReload = moment(currentReload);
    const currentVisit = moment();
    const range = currentVisit.diff(lastReload, "minutes");

    console.log('range', range);
    if (range >= 1) {
      result.currentReload = currentVisit;
      result.reload = true;
    }

    return result;
  }

  async goHealthForm() {
    try {
      this.inAppBrowserService.openInAppBrowser(`https://passport.toyota.astra.co.id:5018/others/form/load?formKey=health-declaration`, '_system');
    } catch (error) {
      this.nestResponse.error(error);
    }
    return true;
  }

}



// WEBPACK FOOTER //
// ./src/bloc/feature/home/home.bloc.ts